//
// Copyright 2026 DXOS.org
//

// @import-as-namespace

export { Checkbox, type CheckboxProps } from '../components/Checkbox/Checkbox.tsx';
export {
  ControlFrame as Frame,
  type ControlFrameProps as FrameProps,
  type ControlFrameVariant as FrameVariant,
} from '../components/ControlFrame/ControlFrame.tsx';
export {
  DateInput as Date,
  type DateInputGranularity as DateGranularity,
  type DateInputProps as DateProps,
  type DateInputType as DateType,
} from '../components/DateInput/DateInput.tsx';
export { Input as Root, type InputProps as RootProps } from '../components/Input/Input.tsx';
export { NumberInput as Number, type NumberInputProps as NumberProps } from '../components/NumberInput/NumberInput.tsx';
export {
  PasswordInput as Password,
  type PasswordInputProps as PasswordProps,
} from '../components/PasswordInput/PasswordInput.tsx';
export { PinInput as Pin, type PinInputProps as PinProps } from '../components/PinInput/PinInput.tsx';
export { Slider, type SliderProps } from '../components/Slider/Slider.tsx';
export { Switch, type SwitchProps } from '../components/Switch/Switch.tsx';
export { Textarea, type TextareaProps } from '../components/Textarea/Textarea.tsx';
